export default {
    title: "Magazzino",
    icon: "mdi-database",
    divider: true,
    groups: [
        "Laser",
        "Admin",
        "Amministrazione",
        "Tecnici",
        "Officina",
        "Magazzino",
        "Schedulazione",
        "Milkrun",
        "Tempi&Metodi",
        "Qualità",
    ],
    submenu: [
        { title: "Imballaggi", route: { name: "Imballaggi" }, groups: ["Amministrazione", "Magazzino", "Tecnici", "Schedulazione", "Milkrun", "Tempi&Metodi", "Laser", "Officina", "Qualità"] },
        {
            title: "Scaffalature",
            route: { name: "Scaffalature", params: {} },
            // Include Ubicazioni: i permessi restano verificati dalle API.
        },
        {
            title: "Ricevimento",
            route: { name: "Ricevimenti", params: {} },
            groups: ["Amministrazione", "Schedulazione", "Magazzino", "Tecnici"],
        },
        {
            title: "ETC Ricevimenti",
            route: { name: "EtcRicevimenti", params: {} },
            groups: ["Amministrazione", "Schedulazione", "Magazzino"],
        },
        {
            title: "PickList Breton",
            route: { name: "PickListBreton", params: {} },
            groups: ["Amministrazione", "Schedulazione", "Magazzino"],
        },

        { title: "Lamiere", route: { name: "Lamiere", params: {} } },
        { title: "Tubi", route: { name: "Tubi", params: {} } },
        { title: "Ricambi", route: { name: "Ricambi", params: {} } },
        {
            title: "Preparazione Ordini",
            route: { name: "PreparazioneOrdini", params: {} },
            groups: ["Amministrazione", "Schedulazione", "Magazzino"],
        },
        {
            title: "Gestione DDT",
            route: { name: "DdtPreparazioni", params: {} },
            groups: ["Amministrazione", "Schedulazione", "Magazzino"],
        },
        { title: "Avanzi Saldatura", route: { name: "Svansi", params: {} } },
        {
            title: "Diagnostica",
            route: { name: "DiagnosticaMagazzino", params: {} },
            groups: ["Amministrazione", "Schedulazione", "Magazzino", "Tecnici"],
        },
        {
            title: "Ordini Consumabili",
            route: { name: "OrdiniConsumabili", params: {} },
            groups: ["Amministrazione", "Magazzino", "Schedulazione"],
        },
    ],
};
